<template lang="pug">
//svg.ticket-card(xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 722 551")
//  defs
//    filter(x="-8.9%" y="-66.7%" width="117.9%" height="233.3%" filterUnits="objectBoundingBox" id="a")
//      feGaussianBlur(stdDeviation="20" in="SourceGraphic")
//    filter(x="-2.2%" y="-3.1%" width="104.4%" height="105.8%" filterUnits="objectBoundingBox" id="b")
//      feOffset(dy="-1" in="SourceAlpha" result="shadowOffsetOuter1")
//      feGaussianBlur(stdDeviation="5" in="shadowOffsetOuter1" result="shadowBlurOuter1")
//      feColorMatrix(values="0 0 0 0 0.885501585 0 0 0 0 0.885501585 0 0 0 0 0.885501585 0 0 0 0.727846372 0" in="shadowBlurOuter1")
//    path(d="M686 0a16 16 0 0116 16v197a24 24 0 100 48v254a16 16 0 01-16 16H16a16 16 0 01-16-16V261a24 24 0 100-48V16A16 16 0 0116 0h670z" id="c")
//  g(transform="translate(24 11)" fill="none" fill-rule="evenodd")
//    rect(fill-opacity=".78" fill="#168BFF" opacity=".2" filter="url(#a)" x="15" y="451" width="672" height="90" rx="8")
//    use(fill="#000" filter="url(#b)" xlink:href="#c")
//    use(fill="#FFF" xlink:href="#c")
//    path(stroke="#EEE" stroke-linecap="square" d="M40 377h622M40 237h622")
//img.ticket-card(src="~assets/ticket.png")
img.ticket-card(src="~assets/ticket2.png")

</template>
<script>
export default {
  name: 'TicketCard',
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.ticket-card
  width: 100%
  height: 100%
</style>
